export default "__VITE_ASSET__88b19eff__"